import React from "react";
import Table, {
  TableCell,
  TableRow,
  TableSectionHeader,
} from "@amzn/meridian/table";
import { calculateTime } from "./SettingsUtil";
import * as Constants from "./SettingsConstant";

const NormalSettingsView = (props) => {
  const state = props.data.viewModel.settingsData;
  const processTimeRange = (data, taskPlan, process) => {
    return data[taskPlan] && data[taskPlan][process]
      ? calculateTime(
          data[taskPlan][process].startTime.time,
          data[taskPlan][process].endTime.time,
        )
      : "";
  };
  return (
    <div>
      <div>
        <Table headerRows={1} showDividers={false} spacing="small">
          <TableRow>
            <TableCell alignmentHorizontal="left">Cycle</TableCell>
            <TableCell alignmentHorizontal="center">Induct Time</TableCell>
            <TableCell alignmentHorizontal="center">Stow Time</TableCell>
            <TableCell alignmentHorizontal="center">Stage Time</TableCell>
            <TableCell alignmentHorizontal="center">Break 1</TableCell>
            <TableCell alignmentHorizontal="center">Lunch</TableCell>
            <TableCell alignmentHorizontal="center">Break 2</TableCell>
            <TableCell alignmentHorizontal="center">Target TPH</TableCell>
            <TableCell alignmentHorizontal="center">Induct PPH</TableCell>
            <TableCell alignmentHorizontal="center">Stow PPH</TableCell>
          </TableRow>
          {Constants.days.map((day) => {
            return [
              <TableSectionHeader>{day}</TableSectionHeader>,
              state[day] && state[day].length ? (
                state[day].map((data) => {
                  if (data.taskPlan) {
                    const inductTime = processTimeRange(
                      data,
                      Constants.taskPlan,
                      Constants.induct,
                    );
                    const stowTime = processTimeRange(
                      data,
                      Constants.taskPlan,
                      Constants.sort,
                    );
                    const stageTime = processTimeRange(
                      data,
                      Constants.taskPlan,
                      Constants.stage,
                    );
                    const break1 = processTimeRange(
                      data,
                      Constants.breaks,
                      Constants.break1,
                    );
                    const lunch = processTimeRange(
                      data,
                      Constants.breaks,
                      Constants.lunch,
                    );
                    const break2 = processTimeRange(
                      data,
                      Constants.breaks,
                      Constants.break2,
                    );

                    return (
                      <TableRow>
                        <TableCell>
                          {data.taskPlan ? data.planDetails.cycleName : ""}
                        </TableCell>
                        <TableCell alignmentHorizontal="center">
                          {inductTime}
                        </TableCell>
                        <TableCell alignmentHorizontal="center">
                          {stowTime}
                        </TableCell>
                        <TableCell alignmentHorizontal="center">
                          {stageTime}
                        </TableCell>
                        <TableCell alignmentHorizontal="center">
                          {data.taskPlan ? break1 : ""}
                        </TableCell>
                        <TableCell alignmentHorizontal="center">
                          {data.taskPlan ? lunch : ""}
                        </TableCell>
                        <TableCell alignmentHorizontal="center">
                          {data.taskPlan ? break2 : ""}
                        </TableCell>
                        <TableCell alignmentHorizontal="center">
                          {data.targetMap && data.taskPlan
                            ? data.targetMap.NODE_TPH
                            : ""}
                        </TableCell>
                        <TableCell alignmentHorizontal="center">
                          {data.targetMap && data.taskPlan
                            ? data.targetMap.INDUCT_PPH
                            : ""}
                        </TableCell>
                        <TableCell alignmentHorizontal="center">
                          {data.targetMap && data.taskPlan
                            ? data.targetMap.STOW_PPH
                            : ""}
                        </TableCell>
                      </TableRow>
                    );
                  } else {
                    return null;
                  }
                })
              ) : (
                <TableRow>
                  <TableCell>Plan not created yet</TableCell>
                </TableRow>
              ),
            ];
          })}
        </Table>
      </div>
    </div>
  );
};

export default NormalSettingsView;



// WEBPACK FOOTER //
// ./src/components/settings/NormalSettingView.js